import React, { useState } from 'react';
import { useIsomorphicEffect } from '../use-isomorphic-effect/use-isomorphic-effect.js';

const randomId = () => `mantine-${Math.random().toString(36).slice(2, 11)}`;
const useReactId = React["useId".toString()] || (() => void 0);
function useClientId() {
  const [uuid, setUuid] = useState("");
  useIsomorphicEffect(() => {
    setUuid(randomId());
  }, []);
  return uuid;
}
function getReactId() {
  const id = useReactId();
  return id ? `mantine-${id.replace(/:/g, "")}` : "";
}
function useId(staticId) {
  return typeof staticId === "string" ? staticId : getReactId() || useClientId();
}

export { useId };
//# sourceMappingURL=use-id.js.map
